import React, {useEffect, useState} from 'react'
import {getTenantParam} from "../../../../../../services/api/apiCommon"
import parseToken from "../../../../../../helpers/parseToken"
import {Spin} from "antd"
import ParamActions from "./ParamActions"

const ParamConfiguration = ({tenantId}) => {
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [listParam, setListParam] = useState([])
    const [typeAction, setTypeAction] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [itemEdit, setItemEdit] = useState({})

    const _onOpen = () => {
        setIsOpen(true)
    }

    const _onCancel = () => {
        setIsOpen(false)
    }

    const _onAddNew = () => {
        setItemEdit({})
        setTypeAction('add')
        _onOpen()
    }

    const _onEdit = (dataItem) => {
        setItemEdit(dataItem)
        setTypeAction('edit')
        _onOpen()
    }

    const _fetchListParam = async () => {
        try {
            const payload = {
                parName: [
                    "NO_STOP_VOICEMAIL",
                    "PHONE_POOL_SIZE",
                    "ALLOW_DNC",
                    "CHANGE_ROUTE_IF_DNC",
                    "AUTO_BOOK"
                ],
                tenantId,
            }
            const response = await getTenantParam(decodeToken.sub, payload)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListParam(data)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchListParam()

        return () => {
            setLoading(false)
            setListParam([])
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className="BlockLeft PageParam mt-3">
            <div className="headerBlock d-flex align-items-start justify-content-between mb-3">
                <h3>Cấu hình tham số</h3>
                <button className="ButtonCustom" onClick={_onAddNew}>
                    <span>Thêm mới</span>
                </button>
            </div>
            <div className="BlockContent">
                <div className="ParamTable">
                    <Spin spinning={loading} tip="Đang lấy dữ liệu">
                        <table>
                            <thead className="ParamHead">
                            <tr>
                                <th className="Stt">STT</th>
                                <th className="ParName">Loại tham số</th>
                                <th className="ParValue">Giá trị</th>
                                <th className="ParTitle">Mô tả</th>
                                <th className="ParAction">Hành động</th>
                            </tr>
                            </thead>
                            <tbody className="ParamBody">
                            {
                                listParam && listParam.length > 0 ? listParam.map((item, index) => (
                                    <tr key={index} className="ParamItem">
                                        <td className="Stt">{index + 1}</td>
                                        <td className="ParName">{item.parName}</td>
                                        <td className="ParValue">{item.parValue}</td>
                                        <td className="ParTitle">{item.parTitle}</td>
                                        <td className="ParAction">
                                            <span
                                                className="material-icons"
                                                onClick={() => _onEdit(item)}
                                            >
                                                border_color
                                            </span>
                                        </td>
                                    </tr>
                                )) : <tr className="NoRecord">
                                    <td colSpan={5}>Không có bản ghi nào.</td>
                                </tr>
                            }

                            {
                                error && error.length > 0 && <tr className="NoRecord Error">
                                    <td colSpan={9}>{error}</td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </Spin>
                </div>
            </div>
            {isOpen && <ParamActions
                isOpen={isOpen}
                tenantId={tenantId}
                typeAction={typeAction}
                itemEdit={itemEdit}
                onCancel={_onCancel}
                onGetListParam={_fetchListParam}
            />
            }
        </div>
    )
}

export default ParamConfiguration
